/**
 * Component: Image Slider
 */

var OplevMere = OplevMere || {};

OplevMere.imageSlider = OplevMere.imageSlider || function () {
	this.init = function () {
		setupOwl();
		//zoom();
	};

	this.setupOwl = function () {
		$.each($('.nc-grid-imageslider__inner'), function(){
			var owl = $(this);
			var $next = owl.next('.nc-grid-imageslider__nav').find(".js-owl-next");
			var $prev  = owl.next('.nc-grid-imageslider__nav').find(".js-owl-prev");

			if(owl.length){

				owl.owlCarousel({
				   	onResized :  novicell.responsiveLazyloadImage.onResize(),
					itemElement: "figure",
					items:1,
					lazyLoad:true,
					loop:false,
					nav:false,
					dots: true,
					navText: ["forrige","næste"],

					// Disable arrow first or last slide
					onTranslated: function(i){
						if(i.item.index == 0){
							$prev.addClass('disabled');
						} else {
							$prev.removeClass('disabled');
						}

						if(i.item.index == i.item.count - 1){
							$next.addClass('disabled');
						} else {
							$next.removeClass('disabled');
						}
					}
				});

				// Set custom next/prev click events for "logged in slider"
				$next.click(function(e){
				        e.preventDefault();
				        owl.trigger('next.owl.carousel');
				})
				$prev.click(function(e){
				        e.preventDefault();
				        owl.trigger('prev.owl.carousel');
				})
			}
		});
	}
    
	return {
		init: init
	}
}();